export const carKeys = {
	all: ['mantang', 'profile'] as const,
	userCarInfo: () => [...carKeys.all, 'userCarInfo'] as const,
	carModelSearch: (text: string) =>
		['mantang', 'carModelSearch', text] as const,
};
